import { ChangeEvent } from "react";

interface CalculatorNumberInputProps {
  label: string;
  value: number | null;
  dataTest: string;
  onChange: (value: number | null) => void;
  step?: number;
}

const CalculatorNumberInput = ({ label, value, dataTest, onChange, step = 0.1 }: CalculatorNumberInputProps) => {
  const updateValue = (event: ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value === "" ? null : Number(event.target.value);
    onChange(Number.isFinite(nextValue) || nextValue === null ? nextValue : null);
  };

  return (
    <label className="block min-w-0 text-xs font-medium text-gray-700 dark:text-gray-300">
      {label && <span className="mb-1.5 block min-h-[2rem] leading-4">{label}</span>}
      <input
        data-test={dataTest}
        type="number"
        step={step}
        value={value ?? ""}
        onChange={updateValue}
        className="w-full rounded border border-gray-300 bg-white px-2.5 py-2 text-sm text-gray-900 outline-none focus:border-green focus:ring-1 focus:ring-green dark:border-gray-600 dark:bg-gray-900 dark:text-gray-100"
      />
    </label>
  );
};

export default CalculatorNumberInput;
